export const guestBooks = [
  {
    id: "the-adoption-paradox",
    title: "The Adoption Paradox: Putting Adoption in Perspective",
    author: "Jean Kelly Widner",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/1c01138696b547774bcbff9104c5facc.jpg",
    affiliateUrl: "https://amzn.to/4eSFZGW",
    published: true
  },
  {
    id: "i-found-my-mom-on-craigslist",
    title: "I Found My Mom on Craigslist",
    author: "Ronald Lee Carlson",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/367d179067b14f9c4b94bc8553ed21c1.jpg",
    affiliateUrl: "https://amzn.to/447lu4E",
    published: true
  },
  {
    id: "dna-results",
    title: "DNA Results: Navigating Peaceful Family Dynamics",
    author: "James Pehkonen",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/703de6e91aaec23f67d152a36977d246.jpg",
    affiliateUrl: "https://amzn.to/4wgi0bW",
    published: true
  },
  {
    id: "wounds-to-wisdom",
    title: "Wounds to Wisdom: The Art of Healing Trauma",
    author: "James Pehkonen",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/5ed76e34873e64693d0b95c197da5cfe.jpg",
    affiliateUrl: "https://amzn.to/4y3yrtU",
    published: true
  },
  {
    id: "finding-mary-smith",
    title: "Finding Mary Smith",
    author: "Al Isaacs",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/797632b829df4c2f66f4a0da595a8de9.jpg",
    affiliateUrl: "https://amzn.to/3R9Gsgh",
    published: true
  },
  {
    id: "the-road-to-moresco",
    title: "The Road to Moresco",
    author: "Mark Jamilkowski",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/f172893757dd04015e27f25bc7823425.png",
    affiliateUrl: "https://amzn.to/4fer6jH",
    published: true
  },
  {
    id: "mask-of-romulus",
    title: "Mask of Romulus",
    author: "Mark Jamilkowski",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/282dc1a74d9ad02cbe4060e5d1aaca13.jpg",
    affiliateUrl: "https://amzn.to/44F8WBx",
    published: true
  },
  {
    id: "foster-mama-journal",
    title: "Foster Mama Journal",
    author: "Kim Patton",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/4ee643af51a35f0b36d779a16cdbab94.jpg",
    affiliateUrl: "https://amzn.to/44P5EM5",
    published: true
  },
  {
    id: "nothing-wasted",
    title: "Nothing Wasted: Struggling Well Through Difficult Seasons",
    author: "Kim Patton",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/9936e0ef29b422f86cf3980f8e78930d.jpg",
    affiliateUrl: "https://amzn.to/3ReYfCM",
    published: true
  },
  {
    id: "journey-to-motherhood",
    title: "Journey to Motherhood: A Place for My Heart to Call Home",
    author: "Kim Patton",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/fa9cc5c56ab84066f2c5a7325e522f50.jpg",
    affiliateUrl: "https://amzn.to/44d16Pz",
    published: true
  },
  {
    id: "adoption-songs",
    title: "Adoption Songs: Heartwarming and Heartbreaking Narratives from the Many Sides of Adoption",
    author: "Lori Evans Ermi",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/75dd26566f9f1fb80ef6f0b31280e06d.jpg",
    affiliateUrl: "https://amzn.to/4aBPVUd",
    published: true
  },
  {
    id: "taking-on-trouble",
    title: "Taking on Trouble: Being Me Is My Power",
    author: "Mike Canfield",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/8527059187939157565cd3cccf1c338e.jpg",
    affiliateUrl: "https://amzn.to/4v8Vq40",
    published: true
  },
  {
    id: "deflating-trouble",
    title: "Deflating Trouble: An Allegory",
    author: "Mike Canfield",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/209431b94c2f00069590776f6a0982db.jpg",
    affiliateUrl: "https://amzn.to/3RdfJzo",
    published: true
  },
  {
    id: "the-trouble-monsters",
    title: "The Trouble Monsters: Lilly and Mia Stand Up to Trouble",
    author: "Mike Canfield",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/0a1ebc5d1db5a479ea108987e1397b39.jpg",
    affiliateUrl: "https://amzn.to/449V6XO",
    published: true
  },
  {
    id: "trouble-comes-to-town",
    title: "Trouble Comes to Town: A Trouble Monster Coloring Book",
    author: "Mike Canfield",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/a095c9977c94e2138349f1dc2362112b.jpg",
    affiliateUrl: "https://amzn.to/4vJ9Clf",
    published: true
  },
  {
    id: "los-problemas-llegan-al-pueblo",
    title: "Los problemas llegan al pueblo: Un libro para colorear del Monstruo del Problema",
    author: "Mike Canfield",
    image: "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/56b083adf304bbf9b367c532856edf6d.jpg",
    affiliateUrl: "https://amzn.to/4gUH5ER",
    published: true
  }
];